import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';
import { TTwoBars, TwoBarParams } from '../cp-barschart/cp-bar';

@Component({
    selector: 'cp-twobarschart',
    templateUrl: './cp-twobarschart.component.html',
    styleUrls: ['./cp-twobarschart.component.css'],
    standalone: false
})
export class CpTwobarschartComponent implements OnChanges {

  @Input() params: TwoBarParams;
  bars: TTwoBars[] = [];
  widthBar = "15%";

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.params && !changes.params.firstChange)
    {
      this.bars = [];
      if (typeof (this.params) !== 'undefined' && typeof (this.params.percentageAppropriateUnderPlanned) !== 'undefined') {
      if(typeof(this.params.plannedValue) !== 'undefined') {
        this.CreatePlannedBar(this.params);

        this.CreateAppropriateBar(this.params, this.bars[0].barHeigth == "0%" ? 42 : 51);

        this.ValidatePercentagePlanned(this.params.percentageAppropriateUnderPlanned);
      }
      else{
        this.CreateAppropriateBar(this.params, 42);
      }
     }
    }
  }

  private CreateAppropriateBar(twoBarsParams: TwoBarParams, positionX: number) {
    let appropriateBar = new TTwoBars();
    appropriateBar.barX = positionX.toString()+'%';
    appropriateBar.barWidth = this.widthBar;
    appropriateBar.barY = this.GetBarPositionY(twoBarsParams.percentageAppropriateUnderPlanned);
    appropriateBar.barHeigth = twoBarsParams.percentageAppropriateUnderPlanned?.toString() + '%';
    appropriateBar.colorFill = "#32285C";
    this.bars.push(appropriateBar);
  }

  private CreatePlannedBar(twoBarsParams: TwoBarParams): void {
    let plannedBar = new TTwoBars();
    plannedBar.barX = "33%";
    plannedBar.barWidth = this.widthBar;
    plannedBar.barY = "0%";
    plannedBar.barHeigth = twoBarsParams.plannedValue != 0 ? "100%" : "0%";
    plannedBar.colorFill = "#ccc";

    this.bars.push(plannedBar);
  }


  private ValidatePercentagePlanned(percentageAppropriateUnderPlanned: number) : void {
    if(percentageAppropriateUnderPlanned > 100) {
      this.bars[0].barHeigth = (100 - (percentageAppropriateUnderPlanned - 100)).toString() + '%';
      this.bars[0].barY = (percentageAppropriateUnderPlanned - 100).toString() + '%';
    }
  }

  private GetBarPositionY(percentageAppropriateUnderPlanned: number): string {
    if(percentageAppropriateUnderPlanned > 100) {
      return '0%';
    }
    else {
      return (100 - percentageAppropriateUnderPlanned).toString() + '%';
    }
  }

}
